import React, { memo } from 'react';
import { SvgIcon } from '@material-ui/core';

const ExpandMoreIcon = memo((props) => (
  <SvgIcon {...props} viewBox="0 0 12 8">
    <path
      d="M2.12266 0.78957L6.00266 4.66957L9.88266 0.78957C10.2727 0.39957 10.9027 0.39957 11.2927 0.78957C11.6827 1.17957 11.6827 1.80957 11.2927 2.19957L6.70266 6.78957C6.31266 7.17957 5.68266 7.17957 5.29266 6.78957L0.702656 2.19957C0.312656 1.80957 0.312656 1.17957 0.702656 0.78957C1.09266 0.40957 1.73266 0.39957 2.12266 0.78957Z"
      fill="currentColor"
    />
  </SvgIcon>
));

export default ExpandMoreIcon;
